import classNames from 'classnames';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React from 'react';
import { useHistory } from "react-router-dom";
import { Toast } from 'primereact/toast';

export const ConfirmRegisterPage = () => {

    const [url, setURL] = React.useState('');
    const [token, setToken] = React.useState('');
    const [submitted, setSubmitted] = React.useState(false);    
    const toast = React.useRef();

    const showFailed = (msg) => {
        toast.current.show({ severity: 'error', summary: 'Failed', detail: msg, life: 3000 });
    };

    let history = useHistory();

    async function clickConfirm(event) {
        event.preventDefault();
        if(!token) {
            showFailed('Token tidak boleh kosong!');
            setSubmitted(true);
        } else {            
            setSubmitted(false);
            history.push(`/confirm-register-message/${token}`);
        }
        
    } 

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <h5>Confirm Register Page</h5>
                    <p>Fill the token you received through emails:</p>
                    
                        <form onSubmit={clickConfirm}>
                            <div className="field p-fluid">                               
                                <InputText id="token" type="text" value={token} onChange={(e) => setToken(e.target.value)} className={classNames({ 'p-invalid': submitted && !token })} />
                                {submitted && !token && <small className="p-error">Enter your token</small>}
                            </div>
                            <Button label="Submit" className="p-button-success mr-2" />
                            <Button label={url} className="p-button-link mb-2 mr-2"></Button>    
                        </form>                              
                </div>
            </div>
        </div>
    );
}
